import { useEffect, useState } from "react";
import { Phone, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const PHONE = "tel:+41766388655";

const UrgencyPopup = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    const timer = setTimeout(() => setShow(true), 20000);
    return () => clearTimeout(timer);
  }, [dismissed]);

  if (!show || dismissed) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" onClick={() => setDismissed(true)}>
      <div className="absolute inset-0 bg-background/60 backdrop-blur-sm" />
      <div
        className="relative glass-card rounded-lg p-8 max-w-sm w-full text-center animate-scale-in glow-md"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setDismissed(true)}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Fermer"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mx-auto mb-5">
          <Phone className="w-7 h-7 text-primary" />
        </div>

        <h3 className="text-xl font-bold mb-2 tracking-tight">Besoin d'aide dans l'urgence ?</h3>
        <p className="text-sm text-muted-foreground mb-6">Appelez-nous directement, un expert vous répond immédiatement.</p>

        <Button size="lg" className="w-full gap-3 h-14 text-base glow-sm" asChild>
          <a href={PHONE}>
            <Phone className="w-5 h-5" /> Appeler Maintenant
          </a>
        </Button>
      </div>
    </div>
  );
};

export default UrgencyPopup;
